import Relation from './relation';

export default class RelationBuilder {
  constructor(name, model, route) {
    this.name  = name;
    this.model = model;
    this.route = route;
  }

  for(repository) {
    return new Relation(repository.backend, this.route, this.model, repository.associations);
  }
}
